<template lang="">
  <div class="grid-cols-3 p-0" style="display: flex !important">
    <div class="col-span-2">
      <div class="dropdown">
        <button
          class="dropdown-toggle btn bg-theme-18 hover:bg-theme-35 rounded-none border-0 w-44 h-16"
          aria-expanded="false"
        >
          <div class="grid grid-cols-3 gap-4">
            <div class="col-span-1 m-auto">
              <img
                :src="imageProfile"
                class="w-8 bg-theme-11 rounded-full"
                alt="avatar"
                crossorigin="anonymous"
              />
            </div>
            <div class="m-auto flex">
              <div class="font-poppins">{{ user?.name }}</div>
              <div class="pl-2 w-4"><ChevronDownIcon /></div>
            </div>
          </div>
        </button>
        <div class="dropdown-menu w-48">
          <div class="dropdown-menu__content box p-2">
            <router-link
              :to="{ name: 'my-profile' }"
              tag="a"
              class="flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-theme-35 rounded-md font-poppins"
              @click="selectMenuOption"
            >
              <UserIcon class="w-4 h-4 mr-2" /> Mi perfil
            </router-link>

            <router-link
              :to="{ name: 'favorites' }"
              tag="a"
              class="flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-theme-35 rounded-md font-poppins"
              @click="selectMenuOption"
            >
              <HeartIcon class="w-4 h-4 mr-2" /> Mis favoritos
            </router-link>
            <a
              href="javascript:;"
              @click="$emit('logout')"
              class="flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-theme-35 rounded-md font-poppins"
            >
              <LogOutIcon class="w-4 h-4 mr-2" /> Cerrar sesión
            </a>
          </div>
        </div>
      </div>
    </div>
    <Cart v-if="!isCpaCompany" />
    <div class="bg-theme-11 border-0 rounded-none">
      <div class="intro-x dropdown m-4">
        <div
          class="dropdown-toggle notification cursor-pointer"
          :class="{
            'notification--bullet':
              lengthMessages !== this.$store.state?.main?.bellMessages.length
          }"
          role="button"
          aria-expanded="false"
          @click="lengthMessages = this.$store.state?.main?.bellMessages.length"
        >
          <BellIcon class="m-auto bell" />
        </div>
        <div
          class="notification-content pt-2 dropdown-menu max-h-96 overflow-auto"
        >
          <div class="notification-content__box dropdown-menu__content box">
            <div
              v-for="(bellMessage, key) in this.$store.state?.main
                ?.bellMessages || []"
              :key="key"
              class="cursor-pointer relative flex items-center"
              :class="{ 'mt-5': key }"
              style="
                background: #f1f1f1;
                padding: 6px;
                border-radius: 10px;
                margin: 12px 0;
                border-left: 3px solid #ce0100;
              "
            >
              <div class="ml-2 overflow-hidden">
                <div class="flex items-center">
                  <a href="javascript:;" class="font-normal mr-5 font-poppins">
                    {{ getMainMessage(bellMessage) }}
                  </a>
                </div>
                <div
                  class="text-xs text-gray-500 ml-auto whitespace-nowrap font-poppins"
                  v-if="false"
                ></div>
              </div>
              <div class="ml-2 w-12 h-12 flex-none image-fit mr-1">
                <img
                  alt="Imagen de notificación"
                  class="rounded-full object-contain"
                  :src="getMainImage(bellMessage)"
                  crossorigin="anonymous"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.bell:hover {
  -webkit-animation: ring 4s 0.7s ease-in-out infinite;
  -webkit-transform-origin: 50% 4px;
  -moz-animation: ring 4s 0.7s ease-in-out infinite;
  -moz-transform-origin: 50% 4px;
  animation: ring 4s 0.7s ease-in-out infinite;
  transform-origin: 50% 4px;
}

@-webkit-keyframes ring {
  0% {
    -webkit-transform: rotateZ(0);
  }
  1% {
    -webkit-transform: rotateZ(30deg);
  }
  3% {
    -webkit-transform: rotateZ(-28deg);
  }
  5% {
    -webkit-transform: rotateZ(34deg);
  }
  7% {
    -webkit-transform: rotateZ(-32deg);
  }
  9% {
    -webkit-transform: rotateZ(30deg);
  }
  11% {
    -webkit-transform: rotateZ(-28deg);
  }
  13% {
    -webkit-transform: rotateZ(26deg);
  }
  15% {
    -webkit-transform: rotateZ(-24deg);
  }
  17% {
    -webkit-transform: rotateZ(22deg);
  }
  19% {
    -webkit-transform: rotateZ(-20deg);
  }
  21% {
    -webkit-transform: rotateZ(18deg);
  }
  23% {
    -webkit-transform: rotateZ(-16deg);
  }
  25% {
    -webkit-transform: rotateZ(14deg);
  }
  27% {
    -webkit-transform: rotateZ(-12deg);
  }
  29% {
    -webkit-transform: rotateZ(10deg);
  }
  31% {
    -webkit-transform: rotateZ(-8deg);
  }
  33% {
    -webkit-transform: rotateZ(6deg);
  }
  35% {
    -webkit-transform: rotateZ(-4deg);
  }
  37% {
    -webkit-transform: rotateZ(2deg);
  }
  39% {
    -webkit-transform: rotateZ(-1deg);
  }
  41% {
    -webkit-transform: rotateZ(1deg);
  }

  43% {
    -webkit-transform: rotateZ(0);
  }
  100% {
    -webkit-transform: rotateZ(0);
  }
}

@-moz-keyframes ring {
  0% {
    -moz-transform: rotate(0);
  }
  1% {
    -moz-transform: rotate(30deg);
  }
  3% {
    -moz-transform: rotate(-28deg);
  }
  5% {
    -moz-transform: rotate(34deg);
  }
  7% {
    -moz-transform: rotate(-32deg);
  }
  9% {
    -moz-transform: rotate(30deg);
  }
  11% {
    -moz-transform: rotate(-28deg);
  }
  13% {
    -moz-transform: rotate(26deg);
  }
  15% {
    -moz-transform: rotate(-24deg);
  }
  17% {
    -moz-transform: rotate(22deg);
  }
  19% {
    -moz-transform: rotate(-20deg);
  }
  21% {
    -moz-transform: rotate(18deg);
  }
  23% {
    -moz-transform: rotate(-16deg);
  }
  25% {
    -moz-transform: rotate(14deg);
  }
  27% {
    -moz-transform: rotate(-12deg);
  }
  29% {
    -moz-transform: rotate(10deg);
  }
  31% {
    -moz-transform: rotate(-8deg);
  }
  33% {
    -moz-transform: rotate(6deg);
  }
  35% {
    -moz-transform: rotate(-4deg);
  }
  37% {
    -moz-transform: rotate(2deg);
  }
  39% {
    -moz-transform: rotate(-1deg);
  }
  41% {
    -moz-transform: rotate(1deg);
  }

  43% {
    -moz-transform: rotate(0);
  }
  100% {
    -moz-transform: rotate(0);
  }
}

@keyframes ring {
  0% {
    transform: rotate(0);
  }
  1% {
    transform: rotate(30deg);
  }
  3% {
    transform: rotate(-28deg);
  }
  5% {
    transform: rotate(34deg);
  }
  7% {
    transform: rotate(-32deg);
  }
  9% {
    transform: rotate(30deg);
  }
  11% {
    transform: rotate(-28deg);
  }
  13% {
    transform: rotate(26deg);
  }
  15% {
    transform: rotate(-24deg);
  }
  17% {
    transform: rotate(22deg);
  }
  19% {
    transform: rotate(-20deg);
  }
  21% {
    transform: rotate(18deg);
  }
  23% {
    transform: rotate(-16deg);
  }
  25% {
    transform: rotate(14deg);
  }
  27% {
    transform: rotate(-12deg);
  }
  29% {
    transform: rotate(10deg);
  }
  31% {
    transform: rotate(-8deg);
  }
  33% {
    transform: rotate(6deg);
  }
  35% {
    transform: rotate(-4deg);
  }
  37% {
    transform: rotate(2deg);
  }
  39% {
    transform: rotate(-1deg);
  }
  41% {
    transform: rotate(1deg);
  }

  43% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(0);
  }
}
</style>
<script>
import { defineComponent } from 'vue'
import Cart from '@/components/cart/Main.vue'
export default defineComponent({
  components: {
    Cart
  },
  data() {
    return {
      lengthMessages: 0
    }
  },
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    imageProfile: {
      type: String
    }
  },
  emits: ['logout'],
  setup() {
    const show = () => {
      cash('#programmatically-dropdown').dropdown('show')
    }
    const hide = () => {
      cash('#programmatically-dropdown').dropdown('hide')
    }
    const toggle = () => {
      cash('#programmatically-dropdown').dropdown('toggle')
    }
    return {
      show,
      hide,
      toggle
    }
  },
  methods: {
    selectMenuOption() {
      cash('body').trigger('click')
    },
    getMainMessage(bellMessage) {
      switch (bellMessage.type) {
        case 'QUOTATION':
          return `Te han enviado un mensaje por la cotización ${bellMessage.data?.quotation_id}`
        case 'STATUS_QUOTATION':
          return `El estatus de la cotización ${bellMessage.data?.id} ha cambiado`
        case 'PRICE_QUOTATION':
          return `El precio de la cotización ${bellMessage.data?.id} ha cambiado`
        case 'MULTI_QUOTATION_CHANGE_PRICE':
          return 'Los precios del carrito han cambiado'
      }
    },
    getMainImage(bellMessage) {
      const imageArray =
        bellMessage?.type === 'QUOTATION'
          ? bellMessage?.data?.quotation?.product?.image
          : bellMessage?.data?.product?.image
      return Array.isArray(imageArray) && imageArray.length
        ? imageArray[0]
        : require('@/assets/images/product.svg')
    }
  },
  computed: {
    isCpaCompany() {
      return this.$store.getters['auth/getCompany'].code == 'cpa'
    }
  }
})
</script>
